import z from 'zod';
export const FIRM_USER_STATUS_INVITED = 'invited';
export const FIRM_USER_STATUS_ACTIVE = 'active';
export const FIRM_USER_STATUS_SUSPENDED = 'suspended';
export const firmUserStatusValue = z.enum([
    FIRM_USER_STATUS_ACTIVE,
    FIRM_USER_STATUS_INVITED,
    FIRM_USER_STATUS_SUSPENDED,
]);
export const firmUserStatus = (value) => firmUserStatusValue.parse(value);
export const isFirmUserStatus = (value) => firmUserStatusValue.safeParse(value).success;
export const isFirmUserStatusInvited = (status) => status === FIRM_USER_STATUS_INVITED;
export const isFirmUserStatusActive = (status) => status === FIRM_USER_STATUS_ACTIVE;
export const isFirmUserStatusSuspended = (status) => status === FIRM_USER_STATUS_SUSPENDED;
//# sourceMappingURL=firm-user-status.js.map